module.exports = __webpack_public_path__ + "static/media/charger-pin-high-power.fd259d72.svg";